import ClientStorage from './clientStorage';
import Cookies from 'js-cookie';
import { getUserViewType } from '../func/helper';

const { isDemoTrading } = getUserViewType(Cookies.get('Global-UserViewType'));

const storage = new ClientStorage(isDemoTrading ? 'tpsl-storage-demo-trading' : 'tpsl-storage', true);

export function addStorage<T>(name: string, value: T) {
  storage.update(name, value);
}

export function removeStorage(name: string) {
  storage.remove(name);
}

export function getStorage(name: string) {
  return storage.get(name);
}
